module.exports = function() {
  return new Worker(__webpack_public_path__ + "d2a89d7b4f756e74fa8d.worker.js");
};